/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip, Typography } from "@mui/material";

const LabelledField = (props) => {

    const {
        label,
        remarks,
        isRequired,
        className,
        variant,
        description,
        mode,
        children,
        style,
        tooltip
    } = props;
    const variantProp = variant ? variant : "overline";
    const hasHelperText = !!description;

    return (
        <div className={`label-field ${className ? className : ""}`} style={style}>
            <Typography variant={variantProp} color='text.secondary' className='label-field-typography'>
                {hasHelperText &&
                    <Tooltip title={description}>
                        <span className='labeled-field-helper-container'>
                            <InfoOutlinedIcon className='labeled-field-helper-icon' />
                        </span>
                    </Tooltip>
                }
                {label} {remarks ? <span className='remarks'>{remarks}</span> : ""}{" "}
                {isRequired &&
                    <span
                        title='This is a required field'
                        className='labeled-field-required labeled-field-required-custom'
                    > * </span>
                }
                {tooltip && <Tooltip title={tooltip} arrow placement="right" classes={{ arrow: "label-field-right-arrow" }}>
                    <span className='labeled-field-tooltip-container custom-tooltip-icon-custom'>
                        <InfoOutlinedIcon className='labeled-field-tooltip-icon custom-tooltip-icon' />
                    </span>
                </Tooltip>}
                {mode === "view-content-only" && !isRequired && <span>(optional)</span>}
            </Typography>

            {children}

        </div>
    );
};

export default LabelledField;
